/**
 * createSplitQueryFromOption
 *
 * Builds the `SplitQuery` a split option stands for, or `undefined` when the
 * option is absent, is `no-split`, or is missing `splitRef`/`actualValue`.
 * Consumers: `formActions.setSelectedSplitOption` for the on-screen selection,
 * and the workflow send path, which needs a query for a target it is not
 * showing.
 *
 * Sole definition of the `splitQuery`-iff-`show-value` invariant: a caller that
 * gets `undefined` back must record `no-split`, never a selected value naming a
 * filter that is not there.
 */

import type { SplitQuery } from '#types/System.types';
import type { FormSplitOption } from './generateSplitOptions';

export const createSplitQueryFromOption = (
    option: FormSplitOption | undefined,
): SplitQuery | undefined => {
    if (!option?.splitRef || !option.actualValue) return undefined;
    return {
        splitRef: option.splitRef,
        queryValue: option.actualValue,
        mode: 'include',
    };
};
